import { getField, updateField } from "vuex-map-fields";
import userService from "../../services/userService";
import authService from "../../services/authService";

const state = {
  form: {
    fname: "",
    lname: "",
    address: "",
    city: "",
    state: "",
    postalCode: "",
    phone: "",
    email: "",
    longitude: "",
    latitude: ""
  },
  users: [],
  contactID: null,
  currentUser: {},
  currentUserOriginal: {},
  currentUserID: null,
  currentUserLocation: null,
  showRegisterModal: false,
  showUpdateModal: false,
  showNetworkAlert: false,
  showDuplicateAlert: false,
  surveyEmailStatus: null,
  stakeholderEmailStatus: null,
  userNames: []
};

const actions = {
  fetchUsers({ commit }) {
    userService.fetchUsers().then(users => {
      commit("FETCH_USERS", users);
    });
  },
  userLookUp({ commit }, user) {
    userService.userLookUp(user).then(response => {
      if (response.data.length > 1) {
        commit("SHOW_DUPLICATE_ALERT");
      } else if (response.data.length === 1) {
        commit("SET_CURRENT_USER", response.data[0]);
        commit("SET_CURRENT_USER_ORIGINAL", response.data[0]);
        commit("SET_CURRENT_USER_ID", response.data[0].id);
        commit("SET_CONTACT_ID", response.data[0].id);
        if (state.currentUser) {
          // only toggle modal if currentUser is not undefined
          commit("TOGGLE_UPDATE_MODAL");
        }
      } else {
        commit("TOGGLE_REGISTER_MODAL");
      }
    });
  },
  async updateUser({ commit }, user) {
    let response = await userService.updateUser(user);
    commit("SET_CURRENT_USER", response.data);
    commit("SET_CURRENT_USER_ORIGINAL", response.data);
  },
  async registerUser({ dispatch, commit }, user) {
    let response = await authService.register(
      user.first_name,
      user.last_name,
      user.postal_code,
      "True",
      user.email
    );
    commit("SET_CURRENT_USER_ID", response.data.user.pk);
    commit("SET_CONTACT_ID", response.data.user.pk);
    dispatch("auth/setToken", response.data.token, { root: true });
  },
  async createGeocode({ commit }, payload) {
    let coordinates = await userService.createGeocode(payload);
    commit("SET_CURRENT_USER_LOCATION", coordinates);
    return coordinates;
  },
  setContactID({ commit }, id) {
    commit("SET_CONTACT_ID", id);
  },
  setCurrentUser({ commit }, user) {
    commit("SET_CURRENT_USER", user);
  },
  setCurrentUserOriginal({ commit }, user) {
    commit("SET_CURRENT_USER_ORIGINAL", user);
  },
  setCurrentUserID({ commit }, id) {
    commit("SET_CURRENT_USER_ID", id);
  },
  clearCurrentUser({ commit }) {
    commit("CLEAR_CURRENT_USER");
  },
  showNetworkAlert({ commit }) {
    commit("SHOW_NETWORK_ALERT");
  },
  showDuplicateAlert({ commit }) {
    commit("SHOW_DUPLICATE_ALERT");
  },
  toggleRegisterModal({ commit }) {
    commit("TOGGLE_REGISTER_MODAL");
  },
  toggleUpdateModal({ state, commit }) {
    if (state.currentUser) {
      // only toggle modal if currentUser is not undefined
      commit("TOGGLE_UPDATE_MODAL");
    }
  },
  emailAllUsers({ commit }, payload) {
    return userService
      .emailAllUsers(payload)
      .then(response => {
        commit("SET_STAKEHOLDER_EMAIL_STATUS", response);
      })
      .catch(error => {
        commit("SET_STAKEHOLDER_EMAIL_STATUS", error);
      });
  },
  getUsers({ commit }) {
    userService.fetchUsers().then(response => {
      commit("SET_USERS", response);
    });
  },
  notifyAdmin({ commit }, payload) {
    return userService
      .notifyAdmin(payload)
      .then(response => {
        commit("SET_SURVEY_EMAIL_STATUS", response);
      })
      .catch(error => {
        commit("SET_SURVEY_EMAIL_STATUS", error);
      });
  },
  getUserNames({ commit }) {
    return userService.getUserNames()
      .then(response => {
        commit("SET_USER_NAMES", response.data)
      })
  }
};

const mutations = {
  updateField,
  FETCH_USERS(state, users) {
    state.users = users;
  },
  SET_CONTACT_ID(state, contactID) {
    state.contactID = contactID;
  },
  CLEAR_CURRENT_USER(state) {
    (state.currentUserID = null),
    (state.contactID = null),
    (state.form.fname = ""),
    (state.form.lname = ""),
    (state.form.postalCode = ""),
    (state.form.longitude = ""),
    (state.form.latitude = ""),
    (state.showRegisterModal = false),
    (state.showUpdateModal = false),
    (state.showNetworkAlert = false);
  },
  SET_CURRENT_USER(state, currentUser) {
    state.currentUser = currentUser;
  },
  SET_CURRENT_USER_ORIGINAL(state, currentUserOriginal) {
    state.currentUserOriginal = currentUserOriginal;
  },
  SET_CURRENT_USER_ID(state, currentUserID) {
    state.currentUserID = currentUserID;
  },
  TOGGLE_REGISTER_MODAL(state) {
    state.showRegisterModal = !state.showRegisterModal;
  },
  TOGGLE_UPDATE_MODAL(state) {
    state.showUpdateModal = !state.showUpdateModal;
  },
  SHOW_NETWORK_ALERT(state) {
    state.showNetworkAlert = true;
  },
  SHOW_DUPLICATE_ALERT(state) {
    state.showDuplicateAlert = true;
  },
  SET_USERS(state, users) {
    state.users = users;
  },
  SET_CURRENT_USER_LOCATION(state, coordinates) {
    state.currentUserLocation = coordinates;
  },
  SET_STAKEHOLDER_EMAIL_STATUS(state, status) {
    state.stakeholderEmailStatus = status;
  },
  SET_SURVEY_EMAIL_STATUS(state, status) {
    state.surveyEmailStatus = status;
  },
  SET_USER_NAMES(state, names) {
    state.userNames = names
  }
};

const getters = {
  form: state => {
    return state.form;
  },
  getField
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
